import React, { useState, useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import { object } from 'prop-types';
import qs from 'qs';

import Prouduct from 'pages/Product';
import Loader from 'components/Loader';

import { SearchContext } from 'context/SearchContext';
import { CountryContext } from 'context/CountryContext';
import { ProductContext } from 'context/ProductContext';

import { redirectToErrorPage } from 'utils/redirectToErrorPage';
import { getArtclesInfo, getDirectArticlesInfoOLD } from 'utils/getArtclesInfo';
import { isGlobalSite } from 'utils/currentLanguage';

export const ProductWithData = withRouter((props) => {
  const { history } = props;
  const { search } = history.location;
  const [searchHistory, setSearchHistory] = useState('');
  const [action] = useState(history.action);

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);

  const { currentCountry } = useContext(CountryContext);
  const contextProduct = useContext(ProductContext);
  const { vehicleType } = useContext(SearchContext);

  const articlesSuccess = (response) => {
    let product =
      response.data && response.data.array && response.data.array[0];
    if (product.directArticle) {
      product.assignedArticle = product.directArticle;
    }

    setLoading(false);
    setData({ product: product });
  };

  const articlesError = (error) => {
    redirectToErrorPage();
    setLoading(false);
    console.error(error);
  };

  useEffect(() => {
    const { country, ...rest } = qs.parse(search, {
      ignoreQueryPrefix: true,
    });

    // Check if URL query is clear
    const isClear = isGlobalSite ? !Object.keys(rest).length : !search;
    if (isClear) return;

    // Keep history before clearing
    setSearchHistory(search);
    isGlobalSite && country ? history.replace({ search: `country=${country}` }) : history.replace({ search: '' });
  }, [search]);

  useEffect(() => {
    const { linkingTargetId, manuId, modId, articleLinkId } = qs.parse(
      props.location.search,
      {
        ignoreQueryPrefix: true,
      }
    );
    const { articleId } = props.match.params;

    const calculatedVehicleType = linkingTargetId && +linkingTargetId > 1000000 ? 'O' : 'P';
    const headers = {
      linkingTargetId: linkingTargetId,
      linkingTargetType: calculatedVehicleType,
      manuId: manuId,
      modId: modId,
      articleCountry: currentCountry,
      articleIdPairs: {
        array: [
          {
            articleId: articleId,
            articleLinkId: articleLinkId,
          },
        ],
      },
    };

    if (contextProduct.product) {
      setLoading(false);
      setData(contextProduct);
    } else {
      if (articleLinkId && linkingTargetId) {
        getArtclesInfo(headers, articlesSuccess, articlesError);
      } else {
        getDirectArticlesInfoOLD(
          {
            articleCountry: currentCountry,
            linkingTargetType: vehicleType,
            articleId: {
              array: [articleId],
            },
          },
          articlesSuccess,
          articlesError
        );
      }
    }
  }, [props.match.params.articleId]);

  if (loading) {
    return <Loader />;
  }

  if (!data) {
    return null;
  }

  return <Prouduct data={data} searchHistory={searchHistory} action={action} {...props} />;
});

ProductWithData.propTypes = {
  location: object.isRequired,
};



// WEBPACK FOOTER //
// ./src/containers/ProductWithData/ProductWithData.js